import { type BuildSchemaInputType } from '../form/schema';

export type BuildFormTrackPayload = Omit<
  BuildSchemaInputType,
  'quizList' | 'materials' | 'aiTutor'
> & {
  quizList: number;
  materials: number;
  aiTutor?: string;
};

export const getBuildFormTrackPayload = (
  values: BuildSchemaInputType,
): BuildFormTrackPayload => {
  const { aiTutor, ...rest } = values;

  return {
    ...rest,
    quizList: values.quizList?.length || 0,
    materials: values.materials?.length || 0,
    ...('aiTutor' in values && {
      aiTutor: aiTutor === undefined ? undefined : JSON.stringify(aiTutor),
    }),
  };
};
